import { SPECIAL_UI_ACCESS_ORGANIZATION_ID } from "../../../organizations.js";

export const commandType = "SCHEDULE_TAKE_PICTURE";
export const label = "Take picture";
export const isAdminOnly = true;
export const isAdvanced = false;
export const organizations = [SPECIAL_UI_ACCESS_ORGANIZATION_ID];
